
$(document).ready(function(){
   // Function to handle scroll event
    $(window).scroll(function () {
      if ($(this).scrollTop() >= 250 ) {
        $('body').addClass('body-scrolled');
      }else if ($(this).scrollTop() == 0) {
        $('body').removeClass('body-scrolled');
      }
    });

  $('.header__megamenu-col .card-collection__subtitle').click(function(){
    let url = $(this).attr('data-url');
    window.location.href = url;
  })

   $('.related-product-list').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      autoplay: false,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    });

  const furl = $('#gallery2-image1').attr('data-src');
  if( furl ){
    $('#gia-fancy').attr('data-src', furl)
  }else{
     $('#gia-fancy').hide();
  }

    Fancybox.bind('[data-fancybox="gallery"]', {
        Slideshow: {
          progressParentEl: (slideshow) => {
            return slideshow.instance.container
          },
        },
      })

  Fancybox.bind('[data-fancybox="gallery2"]', {
        Slideshow: {
          progressParentEl: (slideshow) => {
            return slideshow.instance.container
          },
        },
      })


  // $('.imageModelContent').slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     infinite: true,
  //     autoplay: false,
  //     arrows: true,
  //     dots: false
  // });

  $('.innermain-icon-text').click(function(){
    $('.pro-cnt-form-wrapper').show();
    $('.pro-inq-from-wrapper').hide();
  });

  $('#cut-inq-btn').click(function(){
    openPopup();
    $('.pro-cnt-form-wrapper').hide();
    $('.pro-inq-from-wrapper').show();
  })
  
})

// Get the modal


// Get the image and insert it inside the modal - use its "alt" text as a caption
// var img = document.getElementById("popupImage");
// var replacedImg = document.getElementById("replaced-image");
// var modalImg = document.getElementById("imgInModal");

// var img2 = document.getElementById("popupImage2");
// var replacedImg2 = document.getElementById("replaced-image2");
// var modalImg2 = document.getElementById("imgInModal2");

document.addEventListener("DOMContentLoaded", function() {
  setTimeout(() => {
    $('.imageModelContent').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      autoplay: false,
      arrows: true,
      dots: false
  });
  }, 6000); 
});

// img.onclick = function() {
//   modal.style.display = "block";
// }
// img2.onclick = function() {
//   modal.style.display = "block";
// }

// $(".pro-diamond-text").click(function(e){
//     e.preventDefault();
//     modal.style.display = "block";
// })



// Get the <span> element that closes the modal
// var modelClose = document.getElementById("imageModelclose");

// // When the user clicks on <span> (x), close the modal
// modelClose.onclick = function() {
//   console.log('func call');
//   modal.style.display = "none";
// }

// // Close the modal when clicking outside the modal content
// modal.onclick = function(event) {
//   if (event.target === modal) {
//     modal.style.display = "none";
//   }
// }

function openPopup() {
    const popupOverlay = document.getElementById('product-popup');
    const popupContent = popupOverlay.querySelector('.popup-content');

    // Get the current product URL
    var currentUrl = window.location.href;
    document.getElementById('productUrlDisplay').textContent = currentUrl;
    document.getElementById('productUrl').value = currentUrl;


    // Get the product title and image (this assumes you have them in meta tags or on the page)
    var productTitle = document.querySelector('meta[property="og:title"]') ? document.querySelector('meta[property="og:title"]').content : document.title;
    var productImage = document.querySelector('meta[property="og:image"]') ? document.querySelector('meta[property="og:image"]').content : '';

    // Set the product title and image in the popup
    document.getElementById('productTitleDisplay').textContent = productTitle; 
  
    document.getElementById('productTitle').value = productTitle;
    document.getElementById('productImageDisplay').src = productImage;

    // Display the popup
    popupOverlay.style.display = 'block';
    setTimeout(() => {
        popupOverlay.classList.add('is-visible');
        popupContent.classList.add('is-visible');
    }, 10);
}

document.addEventListener('DOMContentLoaded', () => {
    

    function closePopup() {
        const popupOverlay = document.getElementById('product-popup');
        const popupContent = popupOverlay.querySelector('.popup-content');

        popupOverlay.classList.remove('is-visible');
        popupContent.classList.remove('is-visible');

        // Delay hiding the overlay until after the slide-out transition
        setTimeout(() => {
            popupOverlay.style.display = 'none';
        }, 300);
    }

    // Add event listener to the trigger element
    const triggerElement = document.querySelector('.innermain-icon-text');
    if (triggerElement) {
        triggerElement.addEventListener('click', openPopup);
    } else {
        console.error('Trigger element not found');
    }

    // Optionally, add event listener to close the popup when clicking outside of it
    const popupOverlay = document.getElementById('product-popup');
    if (popupOverlay) {
        popupOverlay.addEventListener('click', (e) => {
            if (e.target === e.currentTarget) {
                closePopup();
            }
        });
    }

    // Ensure closePopup function is available in the global scope if needed
    window.closePopup = closePopup;
});
